// TintiCloud — Infra diversa: NPM, Cloudflare, DBs, E-mail, Redes, Volumes, Backups. Demo.

// Nginx Proxy Manager
export const npmConnection = { status: "connected", version: "v2.15.1", host: "sv1:81", managed: 24, discovered: 5, errors: 2 };
export const npmHosts = [
  { id: 1, domain: "cjudi.com", forward: "cjudi-frontend", port: 80, ssl: true, forceSsl: true, state: "managed", status: "healthy" },
  { id: 2, domain: "smartfolks.com.br", forward: "smartfolks-wordpress", port: 80, ssl: true, forceSsl: true, state: "managed", status: "healthy" },
  { id: 3, domain: "moracomigo.com.br", forward: "moracomigo-web", port: 3000, ssl: true, forceSsl: true, state: "managed", status: "healthy" },
  { id: 4, domain: "tintitech.com.br", forward: "tintitech-web", port: 3000, ssl: true, forceSsl: false, state: "drifted", status: "warning" },
  { id: 5, domain: "legacy.c2desk.com.br", forward: "10.0.0.44", port: 8080, ssl: false, forceSsl: false, state: "discovered", status: "info" },
  { id: 6, domain: "old.smartfolks.com.br", forward: "10.0.0.51", port: 80, ssl: false, forceSsl: false, state: "unmanaged", status: "info" },
  { id: 7, domain: "api.primeencontros.com", forward: "primeagents-web", port: 80, ssl: false, forceSsl: false, state: "managed", status: "error" },
];

// Cloudflare
export const cfZones = [
  { id: "z1", name: "cjudi.com", plan: "Free", status: "active", records: 8, proxied: 5 },
  { id: "z2", name: "smartfolks.com.br", plan: "Pro", status: "active", records: 12, proxied: 9 },
  { id: "z3", name: "tintitech.com.br", plan: "Free", status: "active", records: 10, proxied: 7 },
  { id: "z4", name: "c2desk.com.br", plan: "Free", status: "active", records: 6, proxied: 4 },
  { id: "z5", name: "primeencontros.com", plan: "Free", status: "pending", records: 4, proxied: 2 },
];
export const cfRecords = [
  { type: "A", name: "cjudi.com", content: "151.247.210.24", proxy: true, ttl: "Auto", status: "healthy" },
  { type: "CNAME", name: "www", content: "cjudi.com", proxy: true, ttl: "Auto", status: "healthy" },
  { type: "A", name: "api.cjudi.com", content: "151.247.210.24", proxy: false, ttl: "300", status: "healthy" },
  { type: "MX", name: "cjudi.com", content: "mail.cjudi.com", proxy: false, ttl: "Auto", status: "healthy" },
  { type: "TXT", name: "cjudi.com", content: "v=spf1 include:_spf...", proxy: false, ttl: "Auto", status: "healthy" },
  { type: "A", name: "mariarth", content: "192.168.1.10", proxy: true, ttl: "Auto", status: "warning" },
];

// Registros DNS por zona (gerenciamento). Demo.
export const cfZoneRecords = {
  z1: [
    { id: "r1", type: "A", name: "@", content: "151.247.210.24", proxy: true, ttl: "Auto", status: "healthy" },
    { id: "r2", type: "CNAME", name: "www", content: "cjudi.com", proxy: true, ttl: "Auto", status: "healthy" },
    { id: "r3", type: "A", name: "api", content: "151.247.210.24", proxy: false, ttl: "300", status: "healthy" },
    { id: "r4", type: "MX", name: "@", content: "mail.cjudi.com", proxy: false, ttl: "Auto", status: "healthy" },
    { id: "r5", type: "TXT", name: "@", content: "v=spf1 include:_spf.tinticloud.com ~all", proxy: false, ttl: "Auto", status: "healthy" },
    { id: "r6", type: "CNAME", name: "app", content: "cjudi.com", proxy: true, ttl: "Auto", status: "warning" },
  ],
  z2: [
    { id: "r1", type: "A", name: "@", content: "192.168.1.10", proxy: true, ttl: "Auto", status: "healthy" },
    { id: "r2", type: "CNAME", name: "www", content: "smartfolks.com.br", proxy: true, ttl: "Auto", status: "healthy" },
    { id: "r3", type: "MX", name: "@", content: "mail.smartfolks.com.br", proxy: false, ttl: "Auto", status: "healthy" },
  ],
  z3: [
    { id: "r1", type: "A", name: "@", content: "192.168.1.10", proxy: true, ttl: "Auto", status: "healthy" },
    { id: "r2", type: "A", name: "api", content: "192.168.1.10", proxy: false, ttl: "300", status: "healthy" },
    { id: "r3", type: "CNAME", name: "blog", content: "tintitech.com.br", proxy: true, ttl: "Auto", status: "healthy" },
  ],
  z4: [
    { id: "r1", type: "A", name: "@", content: "151.247.210.24", proxy: true, ttl: "Auto", status: "healthy" },
    { id: "r2", type: "CNAME", name: "www", content: "c2desk.com.br", proxy: true, ttl: "Auto", status: "healthy" },
  ],
  z5: [
    { id: "r1", type: "A", name: "@", content: "45.33.12.9", proxy: false, ttl: "Auto", status: "warning" },
  ],
};

// Bancos de Dados
export const databases = [
  { id: "d1", name: "cjudi-mongo", engine: "MongoDB 7.0", server: "sv3", size: "22.4 GB", conns: 42, status: "healthy" },
  { id: "d2", name: "smartfolks-mysql", engine: "MySQL 8.0", server: "sv2", size: "4.1 GB", conns: 12, status: "healthy" },
  { id: "d3", name: "moracomigo-pg", engine: "PostgreSQL 16", server: "sv1", size: "8.9 GB", conns: 23, status: "warning" },
  { id: "d4", name: "redis-shared", engine: "Redis 7.2", server: "sv1", size: "512 MB", conns: 88, status: "healthy" },
];

// E-mail
export const mailboxes = [
  { id: "m1", address: "contato@cjudi.com", domain: "cjudi.com", quotaUsed: 2.1, quota: 10, status: "healthy" },
  { id: "m2", address: "suporte@cjudi.com", domain: "cjudi.com", quotaUsed: 6.8, quota: 10, status: "warning" },
  { id: "m3", address: "ti@smartfolks.com.br", domain: "smartfolks.com.br", quotaUsed: 1.2, quota: 5, status: "healthy" },
  { id: "m4", address: "no-reply@tintitech.com.br", domain: "tintitech.com.br", quotaUsed: 0.4, quota: 2, status: "healthy" },
];
export const mailConfig = { smtp: "mail.tinticloud.com:587", imap: "mail.tinticloud.com:993", tls: "STARTTLS / SSL", domains: 2, mailboxes: 4 };

// Redes / Volumes / Backups globais (usados nas páginas Infra)
export const networks = [
  { name: "tinti_public", server: "sv1", driver: "bridge", subnet: "172.18.0.0/16", containers: 12, status: "healthy" },
  { name: "tinti_internal", server: "sv1", driver: "overlay", subnet: "10.0.9.0/24", containers: 22, status: "healthy" },
  { name: "cjudi_net", server: "sv1", driver: "bridge", subnet: "172.19.0.0/16", containers: 4, status: "healthy" },
  { name: "edge_net", server: "sv4", driver: "bridge", subnet: "172.20.0.0/16", containers: 4, status: "error" },
];
export const volumes = [
  { name: "cjudi_mongo_data", server: "sv3", driver: "local", size: "24.5 GB", used: 62, status: "healthy" },
  { name: "wp_uploads", server: "sv2", driver: "local", size: "8.1 GB", used: 40, status: "healthy" },
  { name: "backups_vol", server: "sv1", driver: "local", size: "120 GB", used: 78, status: "warning" },
  { name: "pg_data", server: "sv1", driver: "local", size: "8.9 GB", used: 35, status: "healthy" },
];
export const backups = [
  { id: "bkp-901", target: "cjudi-mongo", project: "CJUDI", type: "Snapshot", size: "22.4 GB", when: "20/09/2026 03:00", status: "success" },
  { id: "bkp-900", target: "wp_uploads", project: "Smartfolks", type: "Incremental", size: "820 MB", when: "20/09/2026 03:00", status: "success" },
  { id: "bkp-899", target: "primeagents", project: "PrimeAgents", type: "Full", size: "4.1 GB", when: "19/09/2026 03:00", status: "failed" },
  { id: "bkp-898", target: "c2desk-web", project: "C2Desk", type: "Snapshot", size: "1.2 GB", when: "19/09/2026 03:00", status: "success" },
];
